module.exports = __webpack_public_path__ + "img/1792485489353.3a7fe86b.png";